"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var async_1 = require("async");
var capitalize_1 = __importDefault(require("./lib/capitalize"));
var api_1 = __importDefault(require("./lib/api"));
var AgentResponse_1 = __importDefault(require("./AgentResponse"));
var Logger_1 = __importDefault(require("./Logger"));
var InfoChannel_1 = __importStar(require("./InfoChannel"));
var AbortController_1 = __importDefault(require("./AbortController"));
var Pool_1 = __importDefault(require("./Pool"));
var LatencyTest_1 = __importDefault(require("./Tests/LatencyTest"));
var Test_1 = require("./Tests/Test");
var helpers_1 = require("./helpers");
var removeEmptyElements_1 = __importDefault(require("./lib/removeEmptyElements"));
var DownloadTest_1 = __importDefault(require("./Tests/DownloadTest"));
var UploadTest_1 = __importDefault(require("./Tests/UploadTest"));
var ImgDownloadTest_1 = __importDefault(require("./Tests/ImgDownloadTest"));
var AgentInstructionsInterface_1 = __importDefault(require("./AgentInstructionsInterface"));
var BrowserStorage_1 = __importDefault(require("./Storage/BrowserStorage"));
var StorageInterface_1 = __importDefault(require("./Storage/StorageInterface"));
var defaultState = {
    ticket: null,
    server: null,
    started: false,
    reportId: null,
    completed: false,
    result: {
        download: null,
        upload: null,
        latency: null,
        ipv6: null,
        dnssec: null,
    },
    saveReportRetries: 0,
    testId: 0,
};
var Agent = /** @class */ (function () {
    function Agent(options, eventHandler) {
        var _this = this;
        this.settings = null;
        this.canUseWebsockets = false;
        this.infoChannel = null;
        this.abortController = null;
        this.pool = null;
        this.serverUrl = function (path) {
            if (!_this.state.server) {
                throw new Error('No server selected');
            }
            return "".concat(_this.options.protocol, "://").concat(_this.state.server.url, "/").concat(path);
        };
        this.apiUrl = function (path) { return "".concat(_this.options.protocol, "://").concat(_this.options.url, "/api/").concat(path); };
        /**
         * Handle loaded settings
         *
         * @param data
         */
        this.settingsLoaded = function (data) {
            _this.settings = data;
            if ('hashkey' in data) {
                _this.config['Client.hashkey'] = data.hashkey;
                _this.onSaveConfigurationOption({ 'Client.hashkey': JSON.stringify(data.hashkey) });
            }
            _this.respond(AgentResponse_1.default.CONFIGURATION, _this.settings);
        };
        this.onInfoChannelMessage = function (message) {
            if (message.ticket !== _this.state.ticket) {
                Logger_1.default.log('Received info channel event for old ticket');
                return;
            }
            var _a = message.data, args = _a.args, event = _a.event;
            if (event === 'connectionInfo') {
                _this.respond(AgentResponse_1.default.CONNECTION_INFO, args);
                return;
            }
            if (event === 'measurementInfo') {
                _this.respond(AgentResponse_1.default.MEASUREMENT_INFO, args);
                _this.closeInfoChannel();
            }
        };
        this.ticketFetched = function (data) {
            _this.state.testId += 1;
            _this.state.ticket = data.ticket;
            _this.respond(AgentResponse_1.default.SET_INFO, { ticket: _this.state.ticket });
            if (!_this.state.server || !_this.config['Client.hashkey']) {
                throw new Error('Ticket received but no server selected or hash key set');
            }
            var protocol = (_this.options.protocol === 'https') ? 'wss' : 'ws';
            _this.infoChannel = new InfoChannel_1.default(_this.state.server.url, data.ticket, _this.config['Client.hashkey'], protocol);
            _this.infoChannel.on(InfoChannel_1.InfoChannelEvents.MESSAGE, _this.onInfoChannelMessage);
        };
        this.startTestTasks = function () {
            var protocol = _this.options.protocol;
            var _a = _this.state, ticket = _a.ticket, server = _a.server;
            if (!server) {
                throw new Error('No server');
            }
            if (!ticket) {
                throw new Error('No ticket');
            }
            _this.abortController = new AbortController_1.default();
            var serverUrl = server.url;
            var algorithm = (!_this.canUseWebsockets) ? 'onlyHttp' : _this.config['Measure.Algorithm'] || 'mixed';
            _this.pool = new Pool_1.default(serverUrl, protocol || 'http', ticket, algorithm, _this.state.testId);
            if (_this.config['Measure.Ipv6Url']) {
                _this.runTest(new ImgDownloadTest_1.default('ipv6', _this.config['Measure.Ipv6Url']));
            }
            if (_this.config['Measure.DNSSecUrl']) {
                _this.runTest(new ImgDownloadTest_1.default('dnssec', _this.config['Measure.DNSSecUrl'], true));
            }
            (0, async_1.eachSeries)([
                new LatencyTest_1.default(serverUrl, ticket, _this.pool),
                _this.measurementStarted,
                new DownloadTest_1.default(serverUrl, ticket, _this.pool),
                new UploadTest_1.default(serverUrl, ticket, _this.pool),
            ], _this.runTest, _this.testCompleted);
        };
        this.measurementStarted = function (next) {
            var params = {
                t: _this.state.ticket,
                host: _this.config['Client.host'],
                appname: _this.config['Client.appname'],
                appver: _this.config['Client.appver'],
                language: _this.config['Client.language'],
                key: _this.config['Client.hashkey'],
                latency: _this.state.result.latency || 0,
            };
            if (_this.config['Client.debugtag']) {
                params.debugtag = _this.config['Client.debugtag'];
            }
            if (_this.x_bbk) {
                params.x_bbk = _this.x_bbk;
            }
            if (_this.config['Report.lat']) {
                params.lat = _this.config['Report.lat'];
            }
            if (_this.config['Report.lon']) {
                params.lon = _this.config['Report.lon'];
            }
            if (_this.config['Report.accuracy']) {
                params.accuracy = _this.config['Report.accuracy'];
            }
            (0, api_1.default)(_this.serverUrl('measurementStarted'), params)
                .then(_this.parseSaveReportResponse)
                .then(_this.measurementStartedSucceeded)
                .then(next)
                .catch(next);
        };
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.runTest = function (test, next) {
            if (next === void 0) { next = function () { }; }
            if (typeof test === 'function') {
                test(next);
                return;
            }
            if (_this.abortController && _this.abortController.signal.aborted) {
                next();
            }
            else {
                test.once(Test_1.TestEvents.COMPLETED, next);
                test.once(Test_1.TestEvents.START, _this.testStarted);
                test.once(Test_1.TestEvents.RESULT, _this.saveResult);
                test.on(Test_1.TestEvents.PROGRESS, _this.testProgress);
                test.once(Test_1.TestEvents.ERROR, function (data) { return _this.testError(data, next); });
                if (_this.abortController) {
                    _this.abortController.signal.once('abort', test.abort);
                }
                test.start();
            }
        };
        this.testStarted = function (_a) {
            var testName = _a.testName;
            _this.respond(AgentResponse_1.default.TASK_START, { task: testName });
        };
        this.testProgress = function (_a) {
            var testName = _a.testName, current = _a.current, progress = _a.progress;
            _this.respond(AgentResponse_1.default.TASK_PROGRESS, {
                task: testName,
                progress: progress,
                result: (0, helpers_1.convertToMbits)(current),
            });
        };
        this.testError = function (_a, next) {
            var testName = _a.testName, error = _a.error;
            _this.respond(AgentResponse_1.default.TASK_ERROR, { task: testName, errMsg: error });
            next('Task failed');
        };
        this.saveResult = function (_a) {
            var testName = _a.testName, result = _a.result, warnings = _a.warnings;
            var formattedResult = (testName === 'latency') ? result : (0, helpers_1.convertToMbits)(result);
            _this.state.result[testName] = result;
            _this.respond(AgentResponse_1.default.TASK_COMPLETE, {
                task: testName,
                result: formattedResult,
                warnings: warnings,
            });
        };
        this.testCompleted = function () {
            if (_this.pool) {
                _this.pool.closeAll(function () {
                    _this.respond(AgentResponse_1.default.DEBUG, { name: 'connections', data: (_this.pool) ? _this.pool.connections : null });
                });
            }
            _this.state.completed = true;
            _this.respond(AgentResponse_1.default.TASK_COMPLETE, { task: 'global' });
            if (_this.config['Measure.AutoSaveReport'] && _this.state.result.download && _this.state.result.upload) {
                _this.saveReport();
            }
        };
        this.parseSaveReportResponse = function (json) {
            if (json && !json.error) {
                return json;
            }
            throw new Error(json ? json.error : 'Unexpected response');
        };
        this.measurementStartedSucceeded = function (json) {
            if (json && json.latency) {
                _this.state.result.latency = json.latency;
            }
        };
        this.saveReportSucceeded = function (data) {
            if (data.latency) {
                _this.state.result.latency = data.latency;
            }
            if (data.upload) {
                _this.state.result.upload = data.upload;
            }
            if (data.isp && _this.settings) {
                _this.settings.ispname = data.isp;
            }
            data.lat = _this.config['Report.lat'] || null;
            data.lon = _this.config['Report.lon'] || null;
            data.network = _this.config['Report.network'] || null;
            data.mobnet = _this.config['Report.mobnet'] || null;
            data.ipv6 = _this.state.result.ipv6;
            data.dnssec = _this.state.result.dnssec;
            if (data.lat) {
                data.lat = data.lat.toString();
            }
            if (data.lon) {
                data.lon = data.lon.toString();
            }
            _this.respond(AgentResponse_1.default.SET_INFO, { totBytesReceived: null, totBytesSent: null });
            _this.respond(AgentResponse_1.default.REPORT, data);
            return data;
        };
        this.saveReportFailed = function (ex) {
            _this.state.saveReportRetries += 1;
            Logger_1.default.log('Save report failed', ex);
            if (_this.state.saveReportRetries < 3) {
                Logger_1.default.log('Try save report again');
                _this.saveReport();
            }
        };
        this.options = __assign({ protocol: 'http' }, options);
        this.eventHandler = eventHandler;
        this.state = __assign({}, defaultState);
        this.storage = options.storage || BrowserStorage_1.default;
        if (!('protocol' in this.options)) {
            if (typeof window !== 'undefined' && 'location' in window) {
                this.options.protocol = window.location.protocol.replace(':', '');
            }
            else {
                this.options.protocol = 'https';
            }
        }
        this.config = {
            'Logging.LogToConsole': false,
            'Client.language': 'sv',
            'Client.appname': 'Web',
            'Client.appver': '2.0',
            'Measure.AutoSaveReport': true,
            'Measure.Algorithm': 'mixed',
            'Report.lat': null,
            'Report.lon': null,
            'Report.network': null,
            'Report.mobnet': null,
        };
    }
    Agent.prototype.onClientReady = function () {
        var _this = this;
        this.storage.get('settings').then(function (settings) {
            var hashkey = 'Client.hashkey' in settings ? settings['Client.hashkey'] : null;
            if (hashkey) {
                try {
                    _this.config['Client.hashkey'] = JSON.parse(hashkey);
                }
                catch (ex) {
                    _this.config['Client.hashkey'] = hashkey;
                }
            }
            _this.respond(AgentResponse_1.default.AGENT_READY, settings);
        }).catch(function () {
            _this.respond(AgentResponse_1.default.AGENT_READY, {});
        });
    };
    Agent.prototype.onGetConfiguration = function (consent) {
        var _this = this;
        this.fetchSettings(consent)
            .then(this.settingsLoaded)
            .catch(function (error) { return _this.respond(AgentResponse_1.default.TASK_ERROR, { task: 'init', errMsg: error }); });
    };
    Agent.prototype.onSetConfigurationOption = function (args) {
        this.config = Object.assign(this.config, args);
        if ('Protocol' in args && args.Protocol) {
            this.options.protocol = args.Protocol;
        }
    };
    Agent.prototype.onSaveConfigurationOption = function (options) {
        var _this = this;
        var hashkey = this.config['Client.hashkey'];
        if ('Client.hashkey' in options) {
            try {
                hashkey = JSON.parse(options['Client.hashkey'] || '');
            }
            catch (ex) {
                hashkey = options['Client.hashkey'];
            }
        }
        this.storage.get('settings').then(function (settings) {
            var merged = Object.assign(settings, options);
            (0, removeEmptyElements_1.default)(merged);
            var request = _this.storage.add('settings', merged);
            if (hashkey !== _this.config['Client.hashkey']) {
                request.then(function () {
                    _this.config['Client.hashkey'] = hashkey;
                    _this.send('getConfiguration', {});
                });
            }
        }).catch(function () {
            (0, removeEmptyElements_1.default)(options);
            var request = _this.storage.add('settings', options);
            if (hashkey !== _this.config['Client.hashkey']) {
                request.then(function () {
                    _this.config['Client.hashkey'] = hashkey;
                    _this.send('getConfiguration', {});
                });
            }
        });
    };
    Agent.prototype.onSaveReport = function (data) {
        this.saveReport(data);
    };
    Agent.prototype.onStartTest = function (options) {
        var _this = this;
        if (this.state.started || this.state.completed) {
            Logger_1.default.log('Trying to start test in an invalid state');
            return;
        }
        this.state.started = true;
        if (!this.state.server) {
            this.setServer(options.serverUrl);
        }
        this.testWebsockets(function (result) {
            _this.canUseWebsockets = result;
            Logger_1.default.log("Tested websockets and they ".concat((result) ? 'work' : 'don\'t work'));
            _this.fetchTicket()
                .then(_this.ticketFetched)
                .then(_this.startTestTasks)
                .catch(function (error) { return _this.respond(AgentResponse_1.default.TASK_ERROR, { task: 'init', errMsg: error }); });
        });
    };
    // eslint-disable-next-line class-methods-use-this
    Agent.prototype.onResetTest = function () {
        if (!this.state.started || !this.state.completed) {
            Logger_1.default.log('Trying to reset test in an invalid state', this.state.started, this.state.completed);
            return;
        }
        this.state = __assign({}, defaultState);
        this.onClientReady();
    };
    // eslint-disable-next-line class-methods-use-this
    Agent.prototype.onAbortTest = function () {
        if (!this.state.started || this.state.completed) {
            Logger_1.default.log('Trying to abort test in an invalid state');
            return;
        }
        if (this.abortController) {
            this.abortController.abort();
        }
    };
    Agent.prototype.onQuit = function () {
        if (this.abortController) {
            this.abortController.abort();
        }
    };
    // eslint-disable-next-line class-methods-use-this
    Agent.prototype.onTerminate = function () {
        this.onQuit();
    };
    // eslint-disable-next-line no-unused-vars,class-methods-use-this
    Agent.prototype.onSetSubscription = function (speedId) {
        //
    };
    // eslint-disable-next-line no-unused-vars,class-methods-use-this
    Agent.prototype.onAppendLog = function (logText) {
        //
    };
    // eslint-disable-next-line class-methods-use-this
    Agent.prototype.onAccumulateLog = function () {
        //
    };
    // eslint-disable-next-line class-methods-use-this
    Agent.prototype.onSendLogToServer = function () {
        //
    };
    // eslint-disable-next-line max-len
    // eslint-disable-next-line no-unused-vars,class-methods-use-this,@typescript-eslint/no-unused-vars
    Agent.prototype.onGetContent = function (consent, lang, format) {
        //
    };
    // eslint-disable-next-line class-methods-use-this,no-unused-vars
    Agent.prototype.onListMeasurements = function (from, max) {
        //
    };
    // eslint-disable-next-line class-methods-use-this,no-unused-vars
    Agent.prototype.onCheckHost = function (server) {
        //
    };
    // eslint-disable-next-line class-methods-use-this
    Agent.prototype.onPingSweep = function () {
        //
    };
    /**
     * Delegates messages from the client
     *
     * @link {https://github.com/dotse/bredbandskollen/wiki/Agent-API-v2#instructions-that-the-agent-should-be-able-to-receive} Documentation
     */
    Agent.prototype.send = function (method, data) {
        if (data === void 0) { data = {}; }
        var handler = "on".concat((0, capitalize_1.default)(method));
        if (handler in this) {
            var response = this[handler].call(this, data);
            if (response) {
                this.respond(response.event, response.args);
            }
        }
    };
    /**
     * Sends event to the client/listener
     *
     * @link {https://github.com/dotse/bredbandskollen/wiki/Agent-API-v2#events-that-the-gui-can-receive} Documentation
     */
    Agent.prototype.respond = function (event, data) {
        this.eventHandler(event, data);
    };
    /**
     * Fetch settings from API
     *
     * @param consent
     */
    Agent.prototype.fetchSettings = function (consent) {
        var query = {};
        if ('Client.hashkey' in this.config && this.config['Client.hashkey']) {
            query.key = this.config['Client.hashkey'];
        }
        if (consent) {
            query.consent = consent;
        }
        return (0, api_1.default)(this.apiUrl('servers'), query);
    };
    Agent.prototype.setServer = function (url) {
        if (!this.settings) {
            return null;
        }
        var servers = this.settings.servers;
        var foundServers = servers.filter(function (server) { return server.url === url; });
        if (foundServers.length) {
            this.state.server = foundServers[0];
        }
        else {
            this.state.server = { url: url, name: 'not found', type: 'notfound' };
        }
        return this.state.server;
    };
    Agent.prototype.testWebsockets = function (callback) {
        var cancelled = false;
        if (!this.state.server) {
            callback(false);
            return;
        }
        var timer = setTimeout(function () {
            cancelled = true;
            callback(false);
        }, 10000);
        try {
            var protocol = (this.options.protocol === 'https') ? 'wss' : 'ws';
            var ws = new WebSocket("".concat(protocol, "://").concat(this.state.server.url, "/wstest"));
            ws.onmessage = function (e) {
                if (!cancelled) {
                    clearTimeout(timer);
                    callback(e.data === 'Hello BBK');
                }
            };
        }
        catch (ex) {
            clearTimeout(timer);
            Logger_1.default.log('Websockets do not work in this browser', ex);
            callback(false);
        }
    };
    Agent.prototype.closeInfoChannel = function () {
        if (!this.infoChannel) {
            return;
        }
        this.infoChannel.close();
        this.infoChannel.removeListener(InfoChannel_1.InfoChannelEvents.MESSAGE, this.onInfoChannelMessage);
    };
    Agent.prototype.fetchTicket = function () {
        if (!this.config['Client.hashkey']) {
            throw new Error('No hashkey');
        }
        if (typeof this.config['Client.host'] !== 'string') {
            throw new Error('Invalid host');
        }
        var data = {
            key: this.config['Client.hashkey'],
            host: this.config['Client.host'],
        };
        this.closeInfoChannel();
        return (0, api_1.default)(this.serverUrl('ticket'), data);
    };
    Agent.prototype.saveReport = function (extraData) {
        if (extraData === void 0) { extraData = {}; }
        var data = {
            t: this.state.ticket,
            latency: this.state.result.latency || 0,
            download: (0, helpers_1.convertToMbits)(this.state.result.download) || 0,
            upload: (0, helpers_1.convertToMbits)(this.state.result.upload) || 0,
            key: this.config['Client.hashkey'],
        };
        var params = __assign(__assign({}, extraData), data);
        if (this.x_bbk) {
            params.x_bbk = this.x_bbk;
        }
        if (this.config['Report.lat']) {
            params.lat = this.config['Report.lat'];
        }
        if (this.config['Report.lon']) {
            params.lon = this.config['Report.lon'];
        }
        if (this.config['Report.accuracy']) {
            params.accuracy = this.config['Report.accuracy'];
        }
        (0, api_1.default)(this.serverUrl('saveReport'), params)
            .then(this.parseSaveReportResponse)
            .then(this.saveReportSucceeded)
            .catch(this.saveReportFailed);
    };
    return Agent;
}());
exports.default = Agent;
//# sourceMappingURL=Agent.js.map